/** Shared helpers for AI Workbench approval surfaces (central inbox + scorecard audit panel). */

export type AIWorkApprovalBadgeVariant = 'success' | 'danger' | 'warning' | 'secondary';

export const getAIWorkApprovalBadgeVariant = (status: string): AIWorkApprovalBadgeVariant => {
    if (status === 'approved' || status === 'executed') return 'success';
    if (status === 'requested') return 'warning';
    if (status === 'rejected' || status === 'cancelled') return 'danger';
    return 'secondary';
};

/** Turns snake_case enum values (approvalType, status, taskKind) into human-readable text. */
export const humanizeAIWorkLabel = (value: string): string => value.replaceAll('_', ' ');

/** Compact date + time for approval timestamps, which can span multiple days in the inbox. */
export const formatApprovalTimestamp = (value: string | null | undefined): string => {
    if (!value) return '-';

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '-';

    return date.toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
};
